// 套餐首页
export const packageHome = {
  path: '/home',
  name: 'home',
  meta: {
    title: '新东方专题活动'
  },
  component: () => import('@/page/home/home')
}

// 套餐首页
export const packageRouter = {
  path: '/package',
  name: 'package',
  meta: {
    title: '新东方专题活动'
  },
  component: () => import('@/page/b0marketing/package')
}

// 套餐列表
export const packageListRouter = {
  path: '/package/list',
  name: 'packagelist',
  meta: {
    title: '新东方专题活动'
  },
  component: () => import('@/page/b0marketing/packagelist')
}

// 单课首页
export const singleCourseRouter = {
  path: '/single/course',
  name: 'singlecourse',
  meta: {
    title: '新东方专题活动'
  },
  component: () => import('@/page/b0marketing/singlecourse')
}

// 单课列表
export const singleListRouter = {
  path: '/single/list',
  name: 'singlelist',
  meta: {
    title: '新东方专题活动'
  },
  component: () => import('@/page/b0marketing/singlelist')
}

// 套餐首页  非直播
export const newPackageRouter = {
  path: '/newpackage',
  name: 'newpackage',
  meta: {
    title: '新东方专题活动'
  },
  component: () => import('@/page/b0newmarketing/package')
}

// 套餐列表页  非直播
export const newPackageListRouter = {
  path: '/newpackage/list',
  name: 'newpackagelist',
  meta: {
    title: '新东方专题活动'
  },
  component: () => import('@/page/b0newmarketing/packagelist')
}

// 单课首页  非直播
export const newSingleCourseRouter = {
  path: '/newsingle/course',
  name: 'newsinglecourse',
  meta: {
    title: '新东方专题活动'
  },
  component: () => import('@/page/b0newmarketing/singlecourse')
}

// 单课列表  非直播
export const newSingleListRouter = {
  path: '/newsingle/list',
  name: 'newsinglelist',
  meta: {
    title: '新东方专题活动'
  },
  component: () => import('@/page/b0newmarketing/singlelist')
}

// 高端课程
export const highEndCourseRouter = {
  path: '/highend/course',
  name: 'highendcourse',
  meta: {
    title: '新东方专题活动'
  },
  component: () => import('@/page/highend/highend')
}


// // 落地页测评结果页面
// export const appraisalResult = {
//   path: '/appraisalResult',
//   name: 'appraisalResult',
//   meta: {
//     title: '测评结果'
//   },
//   component: () => import('@/page/publicityPage/appraisalResult')
// }
// export const page404 = {
//   path: '*',
//   name: 'error_404',
//   meta: {
//     title: '404-页面不存在'
//   },
//   component: error_404
// }

// 作为Work组件的子页面展示并且在左侧菜单显示的路由写在appRouter里
// export const appRouter = [
//   {
//     path: '/lessons',
//     name: 'lessons',
//     component: () => import(''),
//     children: [
//       {
//         path: 'course',
//         name: 'course',
//         meta: {
//           keepAlive: true
//         },
//         component: () => import('@/view/course/course')
//       }
//     ]
//   }
// ]
// 所有上面定义的路由都要写在下面的routers里
export const routes = [
  packageHome,
  packageRouter,
  packageListRouter,
  singleCourseRouter,
  singleListRouter,
  newPackageRouter,
  newPackageListRouter,
  newSingleCourseRouter,
  newSingleListRouter,
  highEndCourseRouter,
  {
    path: '/gift/course',
    name: 'GiftCourse',
    component: () => import('../page/gift/course.vue'),
    meta: {
      title: '课程报赠'
    }
  }
]
